import {useMemo} from 'react';
import {BoardCell, useGameBoard} from '../state/signlinesBoardSlice';

interface SignlinesCompletionStats {
    totalTiles: number;
    correctTiles: number;
    incorrectTiles: number;
    isComplete: boolean;
}

export function useGameCompletion(): SignlinesCompletionStats {
    const gameBoard = useGameBoard();

    return useMemo(() => {
        const emptyStats = {
            totalTiles: 0,
            correctTiles: 0,
            incorrectTiles: 0,
            isComplete: false,
        } as SignlinesCompletionStats;

        return gameBoard.reduce((partial: SignlinesCompletionStats, cell: BoardCell) => {
            const correctTile = !!cell.tileId && cell.tileId === cell.location;
            const wrongTile = !!cell.tileId && cell.tileId !== cell.location;
            return {
                totalTiles: partial.totalTiles + 1,
                correctTiles: correctTile ? partial.correctTiles + 1 : partial.correctTiles,
                incorrectTiles: wrongTile ? partial.incorrectTiles + 1 : partial.incorrectTiles,
                isComplete: correctTile && partial.correctTiles === partial.totalTiles,
            } as SignlinesCompletionStats;
        }, emptyStats);
    }, [gameBoard]);
}
